<template>
  <div class="d-flex flex-1 h-100 overflow-auto">
    <v-card
      class="report-container w-100 p-0"
      style="border-radius: 12px; margin-bottom: 24px"
    >
      <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
        <div class="custom-icon-wrapper">
          <v-icon @click="backToAdminPage()"
            >custom-icon left-arrow-icon</v-icon
          >
        </div>
        <v-toolbar-title class="size-16 dark-text">{{
          $t("res_Label_ManageNotificationTemplates")
        }}</v-toolbar-title>
      </v-toolbar>

      <div class="border-top p-4 flex-1 overflow-auto">
        <div
          class="row align-items-start flex-nowrap m-0 gap-2"
          style="flex: unset"
        >
          <div class="col-md-4 p-0">
            <v-label>{{ $t("res_Label_SearchforTemplate") }}</v-label>
            <v-text-field v-model="search_query" label="" solo></v-text-field>
          </div>
          <div class="col-md-4 p-0 h-100">
            <div class="d-flex gap-2 h-100 align-items-end">
              <v-btn color="light-blue" dense @click="clearFields()">{{
                $t("res_ButtonText_Clear")
              }}</v-btn>
              <v-btn color="primary" dense @click="Search(true)">{{
                $t("res_ButtonText_Search")
              }}</v-btn>
              <v-btn color="primary" @click="Add()">{{
                $t("res_ButtonText_Add")
              }}</v-btn>
            </div>
          </div>
        </div>
        <Pagination
          class="mb-2"
          :totalCount="pagingData.totalCount"
          :pageSize="pagingData.pageSize"
          :pageIndex="pagingData.pageIndex"
          @pageIndexChanged="pageIndexChanged"
        ></Pagination>

        <!-- <hr /> -->
        <div class="d-flex flex-1 flex-column overflow-auto mt-2">
          <v-data-table
            :mobile-breakpoint="0"
            class="position-relative white flex-1 d-flex overflow-auto"
            disable-sort
            :headers="headers"
            :items="Template_items"
            :loading="loading"
            loading-text="loading..."
            :no-data-text="$t('res_Label_NoData')"
            :footer-props="{ 'items-per-page-text': 'Items per page' }"
            caption=""
            hide-default-footer
            header-fixed
            :class="{ 'no-data': Template_items.length == 0 }"
            :items-per-page="pagingData.pageSize"
          >
            <template v-slot:no-data>
              <div>
                <img
                  style="width: 118px"
                  src="/assets/images/empty-inbox.svg"
                  alt=""
                />
                <p class="m-0">{{ $t("res_No_new_items_here") }}</p>
              </div>
            </template>

            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.name }}</td>
                <td>{{ row.item.subject }}</td>
                <td class="text-start">
                  <div class="onhover-display">
                    <div class="custom-icon-wrapper">
                      <v-icon
                        v-tooltip.hover="$t('Update')"
                        @click="GetRecord(row.item.id)"
                        >custom-icon white-bg edit-icon</v-icon
                      >
                    </div>
                    <div class="custom-icon-wrapper">
                      <v-icon
                        v-tooltip.hover="$t('res_ButtonText_Delete')"
                        @click="DeleteRecord(row.item.id)"
                        >custom-icon white-bg delete-icon</v-icon
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>

    <v-dialog v-model="upsertTemplateDialog" content-class="fullscreen-dialog">
      <v-card>
        <v-toolbar class="bg-white">
          <v-card-title class="p-0">{{
            $t("res_DialogTitle_AddEditTemplate")
          }}</v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            class="close-btn light-btn"
            icon
            dark
            @click="upsertTemplateDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="d-flex flex-column overflow-auto h-100">
          <div class="grid-1 flex-1 p-3 overflow-auto gap-2">
            <div>
              <v-label>{{ $t("res_Label_Name") }}</v-label>
              <v-text-field
                maxlength="150"
                v-model="NotificaitonTemplate.name"
                label=""
                solo
              ></v-text-field>
            </div>

            <div style="margin-top: 10px">
              <v-label>{{ $t("res_Label_Subject") }} *</v-label>
              <v-text-field
                maxlength="150"
                v-model="NotificaitonTemplate.subject"
                label=""
                solo
              ></v-text-field>
            </div>
            <div style="margin-top: 10px">
              <v-label>{{ $t("res_Label_Body") }} *</v-label>
              <!-- <vue-editor v-model="NotificaitonTemplate.body" style="height: 400px" />-->
              <mc-wysiwyg v-model="NotificaitonTemplate.body"></mc-wysiwyg>
            </div>
          </div>

          <v-card-actions class="gap-2 sticky-actions" style="">
            <v-spacer></v-spacer>
            <v-btn
              class="light-blue"
              style="min-width: 100px !important"
              @click="closeupsertTemplateDialog()"
              >{{ $t("res_ButtonText_Cancel") }}</v-btn
            >
            <v-btn
              class="primary"
              style="min-width: 100px !important"
              @click="upsert()"
              >{{ $t("res_ButtonText_Continue") }}</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template> 

<script>
import axios from "axios";
import router from "@/router/index.js";
import constants from "@/assets/js/constants";
import MultiSelect from "vue-multiselect";
import ManageApplicationRoles from "@/components/ManageApplicationRoles.vue";
import Pagination from "@/components/Pagination.vue";
import StructureUserSelector from "@/components/StructureUserSelector.vue"; 
export default {
  name: "ManageNotificationTemplates",
  components: { 
    MultiSelect,
    ManageApplicationRoles,
    Pagination,
    StructureUserSelector,
  },
  data: function () {
    return {
      loading: false,
      search_query: "",
      All_Template_items: [],
      Template_items: [],
      company_items: [],
      userId: 0,
      manageApplicationRoleDialog: false,
      options: ["list", "of", "options"],
      headers: [
        { text: this.$t("res_GridHeaders_Name"), value: "Name" },
        { text: this.$t("res_GridHeaders_CreatedSubject"), value: "Subject" },
        { text: "", value: "actions", sortable: false, width: "190px" },
      ],
      upsertTemplateDialogMode: "new",
      upsertTemplateDialog: false,
      loginProviders: [
        { id: "1", name: "Local" },
        { id: "3", name: "Microsoft" },
      ],
      privacies: [],
      contactRoles: [],
      applicationRoles: [],
      NotificaitonTemplate: {
        name: "",
        subject: "",
        body: "",
      },
      pagingData: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
      },
    };
  },
  methods: {
    getLoginProviders: function () {
      axios
        .get(constants.baseApiUrl + "Admin/ListLoginProviders")
        .then((res) => (this.loginProviders = res.data))
        .catch((err) => console.warn(err));
    },
    checkArabicEvent(e) {
      const arabicRegex = /^[\u0600-\u06FF\s]+$/;
      if (!arabicRegex.test(e.key)) {
        e.preventDefault();
        window.showAlert(this.$t("res_Msgs_NotValidArabicName"), "warning");
      }
    },
    Search: function (
      isResetPaging,
      PaginationTriggered = false,
      PageNumber = 0,
      PageSize = 10
    ) {

      if (isResetPaging) {
        this.pagingData.totalCount = 0;
        this.pagingData.pageIndex = 0;
      }
    
      if (PaginationTriggered == false) {
        axios
          .get(
            constants.baseApiUrl +
              `Admin/NotificationsTemplates/All?SearchTerm=${this.search_query.trim()}`
          )
          .then((res) => {
            this.All_Template_items = res.data;
            this.Template_items = res.data;
            this.pagingData.totalCount = res.data.length;
          })
          .catch((err) => console.warn(err));
      }  
      else { 
        let startIndex = PageNumber * PageSize;
        this.Template_items = this.All_Template_items.slice(
          startIndex,
          startIndex + PageSize
        );
      }
    },
    backToAdminPage() {
      router.push({ name: 'manageSystemLookups' });
    },
    clearFields() {
      this.search_query = "";
      this.Search();
    },
    clearInputs() {
      let HTMLeditor = document.getElementById("editor");
      if(HTMLeditor != null) {document.getElementById("editor").innerHTML = "";} 
      this.NotificaitonTemplate.name = "";
      this.NotificaitonTemplate.subject = "";
      this.NotificaitonTemplate.body = "";
    },
    Add() {
      this.upsertTemplateDialogMode = "new";
      this.upsertTemplateDialog = true;
      this.clearInputs();
    },
    GetRecord(id) {
      this.clearInputs();
      axios
        .get(constants.baseApiUrl + `Admin/NotificationsTemplates/${id}`)
        .then((res) => {
          this.NotificaitonTemplate = res.data;
          this.NotificaitonTemplate.body = res.data.body; 
          this.upsertTemplateDialogMode = "edit";
          this.upsertTemplateDialog = true;
        })
        .catch((err) => console.warn(err));
    },
    DeleteRecord(id) {
      axios
        .delete(constants.baseApiUrl + `Admin/NotificationsTemplates/${id}`)
        .then((res) => {
          window.showAlert(
            this.$t("res_Msgs_FilingOrClassificationDeleted"),
            "success"
          );
          this.Search(true);
        })
        .catch((err) => console.warn(err));
    },
    upsert() {
      var isFormValid = true;
      isFormValid =
        this.NotificaitonTemplate.subject.trim() != "" &&
        this.NotificaitonTemplate.body.trim() != "";

      if (isFormValid == false) {
        window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
        return;
      }
 
      axios
        .post(
          constants.baseApiUrl + "Admin/NotificationsTemplates",
          this.NotificaitonTemplate
        )
        .then((res) => {
          if (res.data == true) {
            window.showAlert(this.$t("res_Msgs_SuccessfulSave"), "success");
            this.closeupsertTemplateDialog();
            this.clearInputs();
            this.clearFields();
            this.Search(false);
          }
        })
        .catch((err) => console.warn(err));
    },
    closeupsertTemplateDialog() {
      this.NotificaitonTemplate = {
        name: "",
        subject: "",
        body: "",
      };
      this.upsertTemplateDialogMode = "new";
      this.upsertTemplateDialog = false;
    },
    pageIndexChanged(pagingData) {
      this.pagingData.pageSize = pagingData.pageSize;
      this.pagingData.pageIndex = pagingData.pageIndex;
      this.Search(false, true, pagingData.pageIndex, pagingData.pageSize);
    },
  },
  mounted: function () {
    this.contactRoles = constants.contactRoles;
    this.privacies = constants.privacies;
    this.getLoginProviders();
    const intervalId = setInterval(() => {
      if (constants.isApplicaitonRolesLoaded == true) {
        clearInterval(intervalId);
        if (constants.isApplicaitonRolesLoaded == true)
          this.applicationRoles = constants.applicationRoles;
      }
    }, 100);

    this.Search(true);
  },
};
</script>

<style scoped>
.vtooltip {
  background-color: white;
  padding: 5px;
  border-radius: 25px;
}
.report-container .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.report_header {
  height: 50px;
  vertical-align: middle;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.015em;
  color: #667593;
}

.report-container
  .theme--light.v-data-table.v-data-table--fixed-header
  thead
  th,
.report-container .v-data-table__wrapper table thead {
  background-color: #fff;
  box-shadow: none;
}

.report-container {
  height: calc(100vh - 116px);
  display: flex;
  flex-direction: column;
  border-radius: 12px !important;
  overflow: auto;
  box-shadow: none !important;
}

.report-container .border-top {
  display: flex;
  flex-direction: column;
}

.report-container .v-toolbar {
  height: 80px !important;
  padding: 0;
}
.report-container .v-toolbar__content {
  height: 100% !important;
  padding: 24px !important;
}
img#ItemPreview {
  width: 100px;
  margin: 0.5rem 0;
}
.mdi-menu-down {
  filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%)
    hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
}
.v-dialog .v-toolbar__content {
  height: 100% !important;
}
</style> 